export default {
    'navbar.home': '主页',
    'navbar.activity': '活动',
    'navbar.wallt': '钱包',
    'navbar.acting': '代理',
    'navbar.mine': '个人'
};